//
//
//
//
//
//

export default {
    // props: {
    //     popPayMethod: {
    //         type: Boolean,
    //         default: false
    //     }
    // },
    data() {
        return {
            popPayMethod: false,
            payTypeMenus: [
                {
                    label: '微信支付',
                    type: 6
                }
            ],
            payData: null
        };
    },
    methods: {
        /**
         * @description: 弹起支付方式选择框 ， 微信浏览器直接微信支付
         * @param {object}  payData 支付订单数据
         */
        showPayAction(payData) {
            this.payData = payData;
            if (this.$isWeixin()) {
                this.payOrder(7);
            } else {
                this.popPayMethod = true;
            }
        },
        /**
         * @description: 菜单项列表 触发事件
         * @param {type}  menuKey  未知   
         * @param {object}  menuKey  选项列表
         */
        checkPayType(menuKey, menuItem) {
            if (menuKey == 'cancel') {
            } else {
                this.payOrder(menuItem.type);
            }
        },
        payOrder(payWay) {
            let that = this;
            // that.$vux.loading.show();
            console.log('订单数据'+ JSON.stringify(that.payData));
            var redirect_url = sessionStorage.domainURL + '/LonBonStore/#/rechargeResult?redirect=true';
            var payOrder = {
                description: '订单支付',
                payWay: payWay,
                wapUrl: sessionStorage.domainURL,
                wapName: '来邦移动商城',
                returnUrl: redirect_url,
                ...that.payData
            };
            var data = {
                order: JSON.stringify(payOrder),
                accountId: that.payData.accountId
            };
            console.log(data);
            that.$axios
                .post('/api/v1.0/familyApp/vip/wechat/order', that.qs.stringify(data))
                .then(function(response) {
                    that.$vux.loading.hide();
                    if (response.status == 200) {
                        if (payWay == 6) {
                            //微信外支付
                            var weChatOrder = response.body.weChatOrder;
                            var url = weChatOrder.mwebUrl + '&redirect_url=' + encodeURIComponent(redirect_url);
                            window.location.href = url;
                        } else if (payWay == 7) {
                            //微信内支付
                            that.inWxPay(response.body.weChatOrder);
                        }
                    }
                })
                .catch(function() {
                    that.$vux.loading.hide();
                });
        },
        //微信内支付
        inWxPay(data) {
            let that = this;
            let wxForm = {
                appId: data.appId,
                timeStamp: data.timeStamp,
                nonceStr: data.nonceStr,
                package: data.package,
                signType: data.signType,
                paySign: data.paySign
            };
            console.log(wxForm);
            WeixinJSBridge.invoke('getBrandWCPayRequest', wxForm, function(res) {
                console.log(res);
                if (res.err_msg == 'get_brand_wcpay_request:ok') {
                    that.$vux.toast.show({
                        text: '支付成功',
                        type: 'success'
                    });
                    // 跳转页面
                    that.$router.push('/rechargeResult?memberRechargeOrderId=' + data.orderId +  '&price=' + that.payData.amount);
                } else {
                    that.$vux.toast.show({
                        text: '支付失败',
                        type: 'cancel'
                    });
                }
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/member/payMethod.vue